import { Mail, MessageSquare } from "lucide-react";

export default function ContactPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-8 md:py-16 animate-fade-in" data-testid="contact-page">
      <div className="text-center max-w-xl mx-auto">
        <p className="text-xs font-medium tracking-widest uppercase text-emerald-600 mb-3">Get in touch</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mb-4" data-testid="contact-title">
          Contact Us
        </h1>
        <p className="text-base text-muted-foreground mb-10 leading-relaxed">
          Have a question or need help? Please send all inquiries to our support email below.
        </p>
        <div className="inline-flex items-center gap-3 px-6 py-4 rounded-sm border border-border bg-white/80 backdrop-blur-sm shadow-sm" data-testid="contact-email-display">
          <div className="h-10 w-10 rounded-lg bg-emerald-50 flex items-center justify-center">
            <Mail className="h-5 w-5 text-emerald-600" />
          </div>
          <div className="text-left">
            <p className="text-xs font-medium tracking-wide uppercase text-muted-foreground">Email us at</p>
            <a href="mailto:support@clickcolony.com" className="text-lg font-semibold text-foreground hover:text-emerald-600 transition-colors" data-testid="contact-email-link">
              support@clickcolony.com
            </a>
          </div>
        </div>
        <div className="mt-8 flex items-center justify-center gap-2 text-muted-foreground">
          <MessageSquare className="h-4 w-4" />
          <p className="text-sm">We typically respond within 24 hours</p>
        </div>
      </div>
    </div>
  );
}
